module.exports = __webpack_public_path__ + "static/img/mp3.c873b05f.jpg";